import { render, staticRenderFns } from "./save-space.vue?vue&type=template&id=35a3b1e1&scoped=true"
import script from "./save-space.vue?vue&type=script&lang=js"
export * from "./save-space.vue?vue&type=script&lang=js"
import style0 from "./save-space.vue?vue&type=style&index=0&id=35a3b1e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3b1e1",
  null
  
)

export default component.exports